<script>
    export let content;
</script>

<p>{content}</p>

<style>
	p {
		margin: 0;
		padding-top: 0;
		padding-bottom: 20px;
		text-align: center;
	}
</style>